
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.313 10.508a2.627 2.627 0 00-2.626 2.626v3.609a2.627 2.627 0 002.626 2.627h5.433v5.743l2.594-1.281 1.613 2.653 3.438-1.698-1.612-2.653 2.465-1.217-1.958-1.547h1.4a2.627 2.627 0 002.627-2.627v-3.609a2.627 2.627 0 00-2.626-2.627H9.313zm5.433 7.429H9.313c-.659 0-1.194-.535-1.194-1.194v-3.609c0-.66.535-1.194 1.194-1.194h13.374c.659 0 1.194.535 1.194 1.194v3.609c0 .66-.535 1.194-1.194 1.194H19.45l-4.705-3.32v3.32zm1.433-.555l2.616 1.846 1.782 1.408-1.834.905 1.612 2.654-.86.424-1.612-2.653-1.704.841v-5.425z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM1.433 16C1.433 7.955 7.955 1.433 16 1.433S30.567 7.955 30.567 16 24.045 30.567 16 30.567 1.433 24.045 1.433 16z","fill":"#A4A8C0"}})])
          )
        }
      }
    